import { ProductionOverview } from "../Models/Production/ProductionOverview"
import { HttpHelper } from "./HttpHelper"

export abstract class ProductionOverviewHelper{
    private static baseUrl = HttpHelper.GetUrlBaseApi() + "api/" + "ProductionOverview"
    public static async GetOverview(){
        var urlForRequest = this.baseUrl
        return (await HttpHelper.GetRequestForApi<ProductionOverview[]>(urlForRequest))
    }

    public static async UpdateOverview(overview: ProductionOverview, token: string){
        var urlForRequest = this.baseUrl + "/" + overview.id
        return (await HttpHelper.UpdateRequestForApi<ProductionOverview>(urlForRequest, overview, token))
    }

    public static async AddOverview(overview: ProductionOverview, token: string){
        var urlForRequest = this.baseUrl
        return (await HttpHelper.PostRequestForApi<ProductionOverview>(urlForRequest, overview, token))
    }

    public static async DeleteOverview(overview: ProductionOverview, token: string){
        var urlForRequest = this.baseUrl + "/" + overview.id
        return (await HttpHelper.DeleteRequestForApi<ProductionOverview>(urlForRequest, overview, token))
    }

    
      public static async ExportSetting(items: ProductionOverview[], token: string) {
        var urlForRequest = this.baseUrl + '/ExportToJSON';
        await HttpHelper.PostRequestForApiForFile(urlForRequest, items, token);
      }
}